import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { MSAL_INSTANCE } from '@azure/msal-angular';

import { routes } from './app.routes';
import { provideServiceWorker } from '@angular/service-worker';
import { provideHttpClient } from '@angular/common/http';
import {
  httpClientFeatures,
  msalProviders,
} from './auth/msal';
import { ChunkLoadErrorHandler } from './services/chunk-load-error-handler';
import { provideChunkRecovery } from './services/chunk-recovery-provider';
import { DarkModeSwitcherService } from './services/dark-mode-switcher';
import { AppUpdateService } from './services/app-update';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
    provideChunkRecovery(),
    provideRouter(routes),
    provideHttpClient(...httpClientFeatures),
    ...msalProviders,
    provideAppInitializer(() => inject(MSAL_INSTANCE).initialize()),
    provideAppInitializer(() => {
      inject(DarkModeSwitcherService);
      inject(AppUpdateService);
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !environment.isLocal,
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
